








































































































































import http from "@/axios/http-common";
// import { resepStore } from "@/store/modules/resep";
import { join, values, mapValues } from "lodash";
import { Vue, Component, Watch, Prop, Ref } from "vue-property-decorator";
import { AxiosError } from "node_modules/axios";
import { appModule } from "@/store/modules/app";
import ObatItemTemplate from "../resep/ObatItemTemplate.vue";
import CardResepItems from "@/components/pemeriksaan/resep-obat/CardResepItems.vue";
import { userModule } from "@/store/modules/user";

interface PreviewItem {
  nama: string;
  text: Text;
}

@Component({
  components: {
    ObatItemTemplate,
    CardResepItems
  }
})
export default class CardListTemplateResep extends Vue {
  @Prop() items = [];
  public masterListTemplate = [
    {
      id: 1,
      nama: "Obat Pusing",
      text:
        "R/ Paracetamol No.XXI \r\n    S3DD1\r\nR/ Ambroxol No.VI \r\n    S1DD2"
    },
    {
      id: 2,
      nama: "Obat Aneh",
      text:
        "R/ Obat Apa Gitu No.XXI \r\n    S3DD1\r\nR/ Obat Aneh Banget No.VI \r\n    S1DD2"
    },
    {
      id: 3,
      nama: "Obat Lainnya",
      text:
        "R/ Lainnya yang satu No.XXI \r\n    S3DD1\r\nR/ Lainnya yang dua No.VI \r\n    S1DD2"
    }
  ];
  public preview = {
    nama: "",
    text: "",
    items: []
  };
  public showList = true;
  public input = {
    nama: "",
    text: "",
    items: []
  };
  public listTemplate = [];
  public highlighted = null;
  public errItem = {};
  public showAlert = false;
  public saving = false;

  @Prop() showed: boolean;

  @Prop() assign: string;

  @Prop() resepText: Text;

  get stateUser() {
    return userModule.user;
  }

  get templateRanap() {
    return this.stateUser.unit_id >= "50";
  }

  mounted() {
    this.listTemplate = [];
    this.showList = true;
    this.resetPreview();
  }

  resetPreview() {
    this.preview = {
      nama: "",
      text: "",
      items: []
    };
  }

  getListTemplate() {
    http.getData("/template/resep-obat").then(response => {
      this.listTemplate = response.data.data;
    });
  }

  addItem() {
    console.log("add item");
    this.$emit("assign-resep-template", this.preview.text ?? "");
  }

  previewItem(item) {
    this.preview = item;
  }

  saveTemplate() {
    // this.listTemplate.push({ id: 4, ...this.input });
    // this.showList = false;
    if (!this.saving) {
      this.saving = true;
      http
        .postData("/template/resep-obat", this.input)
        .then(() => {
          // this.getListTemplate();
          appModule.sendSuccessNotice("Berhasil menyimpan template resep");
          appModule.closeNoticeWithDelay();

          this.close();
        })
        .catch(errors => {
          console.log(errors);
          this.showErrorAlert(errors);
        })
        .then(() => {
          this.saving = false;
        });
    } else {
      alert("masih ada proses menyimpan sedang berjalan....");
    }
  }

  showErrorAlert(err: AxiosError) {
    const dt = err.response;
    let message = "";
    if (!dt) {
      return;
    }
    if (dt["status"] == 422) {
      message = join(
        values(
          mapValues(err.response.data.errors, function(val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
    } else {
      message = `ERR ${err.response.status}: ${err.response.data.message}`;
    }

    appModule.sendErrorAlert(message);
  }

  close() {
    this.$emit("close-modal");
    this.items = [];
  }

  @Watch("showList")
  changedShowList(show: boolean) {
    if (!show) {
      this.input.nama = "";
      this.input.text = "";
      this.input.items = [];
    }
  }

  @Watch("showed")
  changedShowed(status: boolean) {
    console.log("showed: " + status);
    if (status) {
      if (this.showList) {
        this.getListTemplate();
      } else if (!this.showList) {
        this.input.text = String(this.resepText);
        this.input.items = this.items;
      }
      // this.listTemplate = this.masterListTemplate;
    } else {
      this.listTemplate = [];
      // this.showList = true;
      this.resetPreview();
      this.highlighted = null;
    }
  }

  @Watch("assign")
  changedAssign(val: string) {
    if (val === "list") {
      this.showList = true;
    } else if (val === "input") {
      this.showList = false;
      this.$nextTick(function() {});
    }
  }
  public rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  public entries = [];
  public isLoading = false;
  public model = null;
  public search = null;

  public _timerId;
  // listAturanPakai = [];
  // searchString = null;
  // aturan_pakai: {
  //   id: string;
  //   nama: string;
  // };

  @Ref() readonly searchBox!: HTMLInputElement;

  selectObat(val) {
    this.search = null;
    this.entries = [];
    this.addObatSingle(val);

    this.$nextTick(() => {
      this.searchBox.blur();
    });
  }
  // items: Array<ObatSingle>;
  addObatSingle(obat) {
    if (obat) {
      this.input.items.push({
        obat_nama: obat.nama,
        qty: null,
        qty_unit: obat.satuan,
        obat_id: obat.id,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: null
      });
    } else {
      this.input.items.push({
        obat_nama: "",
        qty: null,
        qty_unit: "",
        obat_id: null,
        ap_tambahan: null,
        ap_template_id: null,
        ap_template_nama: null,
        r: null
      });
    }
  }

  @Watch("search")
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.search === null || this.search.length < 3) return;

      this.isLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.search }
        })
        .then(res => {
          this.entries = res.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  }
  // @Watch("searchString")
  // searched() {
  //   this.listAturanPakai = [];
  //   clearTimeout(this._timerId);
  //   this._timerId = setTimeout(() => {
  //     if (this.searchString === null || this.searchString.length < 2) return;
  //     this.searchAturanPakai(this.searchString);
  //   }, 500);
  // }
  // searchAturanPakai(termSearch) {
  //   http
  //     .getDataParam(`/aturan-pakai/search`, {
  //       params: { term: termSearch },
  //     })
  //     .then((res) => {
  //       this.listAturanPakai = res.data;
  //     })
  //     .finally();
  // }
  // changeAturanPakai(val, i) {
  //   if (val) {
  //     console.log("aturan pakai", i, ":", val);
  //     // alert(this.item.obat_nama);
  //     this.items[i].ap_template_id = val.id;
  //     this.items[i].ap_template_nama = val.nama;
  //     this.items[i].aturan_pakai.id = val.id;
  //     this.items[i].aturan_pakai.nama = val.nama;
  //     // this.items.ap_template_nama = this.item.aturan_pakai.nama;
  //     // this.items.ap_template_id = this.item.aturan_pakai.id;
  //     // this.$nextTick(() => {
  //     //   this.jml.focus();
  //     // });
  //   }
  // }
  itemColor(index) {
    return index % 2 === 0 ? "grey lighten-3" : "";
  }

  removeItem(idx) {
    this.input.items.splice(idx, 1);
  }
}
